/** Accent colors people can pick in Settings. Keep in sync with User::ACCENTS and styles/accents.css. */
export const ACCENTS = [
  { id: "indigo", label: { id: "accent.indigo" }, swatch: "oklch(51.1% 0.262 276.966)" },
  { id: "blue", label: { id: "accent.blue" }, swatch: "oklch(54.6% 0.245 262.881)" },
  { id: "violet", label: { id: "accent.violet" }, swatch: "oklch(54.1% 0.281 293.009)" },
  { id: "pink", label: { id: "accent.pink" }, swatch: "oklch(59.1% 0.293 322.896)" },
  { id: "teal", label: { id: "accent.teal" }, swatch: "oklch(51.1% 0.096 186.391)" },
  { id: "emerald", label: { id: "accent.emerald" }, swatch: "oklch(50.8% 0.118 165.612)" },
  { id: "orange", label: { id: "accent.orange" }, swatch: "oklch(55.3% 0.195 38.402)" },
  { id: "graphite", label: { id: "accent.graphite" }, swatch: "oklch(21% 0.006 285.885)" },
] as const

export type AccentId = (typeof ACCENTS)[number]["id"]

export const DEFAULT_ACCENT: AccentId = "indigo"

/** Puts the accent on <html> so the CSS tokens switch. Indigo (or null) is the default and sets nothing. */
export function applyAccent(accent: string | null | undefined) {
  if (typeof document === "undefined") return
  const root = document.documentElement
  if (accent && accent !== DEFAULT_ACCENT) root.setAttribute("data-accent", accent)
  else root.removeAttribute("data-accent")
}
